import { useQuery } from "react-query";
import { get_performance_term } from "../../../faunadb/queries/performance";

export default function usePerformanceTermDetail(client, id) {
    return useQuery(["performance_term_detail", id], () => get_performance_term(client, id), { refetchOnWindowFocus: false })
}